import { render } from "./ConfusionMatrixItems.vue?vue&type=template&id=5e0d27ae&scoped=true"
import script from "./ConfusionMatrixItems.vue?vue&type=script&lang=js"
export * from "./ConfusionMatrixItems.vue?vue&type=script&lang=js"

import "./ConfusionMatrixItems.vue?vue&type=style&index=0&id=5e0d27ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e0d27ae"]])

export default __exports__